<template>
  <main
    v-if="joinery"
    class="joinery">
    <article
      v-for="(project, key) in joinery"
      :key="`project${key}`"
      class="joinery__item">
      <slideshow :items="project.slideshow" />
      <h3>
        {{ `${project.name} (${project.year})` }}
      </h3>
      <div
        class="wysiwyg"
        v-html="project.details"></div>
    </article>
  </main>
</template>

<script>
import Slideshow from '@/components/Slideshow'

export default {
  name: 'Joinery',
  components: {
    Slideshow
  },
  data() {
    return {
      joinery: null
    }
  },
  async created() {
    this.joinery = await this.getJoinery()

    this.$Progress.finish()
  },
  methods: {
    getJoinery() {
      return new Promise((resolve, reject) => {
        this.$http.get(`${process.env.VUE_APP_API_ADDRESS}/joinery`, {
          headers: {
            'Authorization': `Basic YXBwOmNJbnAgSnUxOSBBNWRkIEVEVkIgREViNCBvZ2Rp`
          }
        })
          .then(response => response.json())
          .then(result => resolve(result))
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$Progress.start()
    })
  }
}
</script>

<style lang="scss" scoped>
.joinery {
  @include page($margin: true);

  &__item {
    font-family:$maison;
    margin: $site-padding 0 #{$site-padding * 4} 0;
    border-top: 2px solid $color;
    padding: $site-padding 0 0 0;
    h3 {
      font-size:$body;
    }
    div {
      max-width:75%;
    }
  }

  @include mobile {
    &__item {
      margin: $site-padding 0 #{$site-padding * 2} 0;

      h3 {
        font-size:$body--m;
        margin:2.5rem 0 0 0;
      }
      div {
        max-width: unset;
      }
    }
  }
}
</style>
